import React from "react";
import Footer from "./Footer";

const ServiceLayout = ({ children }) => {
  return (
    <>
      {children}
      <Footer />
    </>
  );
};

export default ServiceLayout;
